import React, { useRef } from 'react';
import { Row, Col } from 'antd';
import { Step } from '@/hooks';
import { StepIcon } from './components/StepIcon';
import { HorizontalButtons } from './components/HorizontalButtons';
import { DIRECTION } from '@/components/views/Resolution886/enums';
import * as S from './styles';

interface StepsNavigationProps {
	steps: Step[];
	currentStep: number;
	isComplete: boolean;
	direction?: DIRECTION;
	onStepNagivationClick: (step: number) => Promise<void>;
}

const DEFAULT_STEPS_LENGTH = 12;

export function StepsNavigation({
	steps,
	isComplete,
	currentStep,
	direction = DIRECTION.VERTICAL,
	onStepNagivationClick
}: Readonly<StepsNavigationProps>): JSX.Element {
	const elementRef = useRef<HTMLDivElement | null>(null);

	const mappedSteps = steps.map((item, index) => {
		item.icon = (
			<StepIcon
				key={item.name}
				position={index}
				isComplete={isComplete}
				currentStep={currentStep}
				name={item.description}
				onStepNagivationClick={onStepNagivationClick}
			/>
		);
		return item;
	});

	if (direction === DIRECTION.VERTICAL || steps.length <= DEFAULT_STEPS_LENGTH) {
		return (
			<Row justify="center">
				<S.Container xs={24}>
					<Row justify="center">
						<Col xs={20}>
							<S.CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
							/>
						</Col>
					</Row>
				</S.Container>
			</Row>
		);
	}

	return (
		<Row justify="center">
			<S.Container xs={24}>
				<HorizontalButtons elementRef={elementRef}>
					<Col xs={20}>
						<S.CustomDivOverflow ref={elementRef}>
							<S.CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
							/>
						</S.CustomDivOverflow>
					</Col>
				</HorizontalButtons>
			</S.Container>
		</Row>
	);
}
